export function getPlatformName(): string {
  return process.env.REACT_APP_ACTIVE_DOMAIN === 'bexio' ? 'bexioSync' : 'BedayaSync';
}
